var React = require('react');

function Video (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.375 0H0.375V18H18.375V0ZM6.38326 14.368L14.1667 9.85217V8.14836L6.38326 3.63256L4.875 4.48386V13.5154L6.38326 14.368Z","fill":"#121212"}));
}

Video.defaultProps = {"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none"};

module.exports = Video;

Video.default = Video;
